<template>
  <section v-if="item.title && item.img">
    <div
      class="d-flex align-center item"
      :style="`background-image: url(${files + item.img})`"
    >
      <v-container class="py-10 py-md-13 py-lg-16 position-relative">
        <v-row no-gutters>
          <v-col cols="12" sm="9" md="8" lg="6" xl="5">
            <div
              class="
                white--text
                text-h5 text-md-h4 text-center text-md-left
                font-weight-bold
              "
            >
              {{ item.title }}
            </div>

            <div
              v-if="item.text"
              class="
                white--text
                text-body-1
                font-weight-regular
                mt-4 mt-md-6
                item-text
              "
              v-html="item.text"
            ></div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
const _config = {
  mod: "best-solution",
};

export default {
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
};
</script>

<style lang="scss" scoped>
.item {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left center;
  min-height: 440px;
  position: relative;

  &:before {
    background: rgb(40, 40, 40);
    background: -moz-linear-gradient(
      90deg,
      rgba(40, 40, 40, 1) 0%,
      rgba(251, 251, 251, 0) 100%
    );
    background: -webkit-linear-gradient(
      90deg,
      rgba(40, 40, 40, 1) 0%,
      rgba(251, 251, 251, 0) 100%
    );
    background: linear-gradient(
      90deg,
      rgba(40, 40, 40, 1) 0%,
      rgba(251, 251, 251, 0) 100%
    );
    content: "";
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#282828",endColorstr="#fbfbfb",GradientType=1);
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  &-text {
    line-height: 1.6;
  }
}
</style>
